import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../app/globals';

@Component({
  selector: 'app-assessment-error-page',
  templateUrl: './assessment-error-page.component.html',
  styleUrls: ['./assessment-error-page.component.scss']
})
export class AssessmentErrorPageComponent implements OnInit {
    errorMessage: string;

    constructor(
        private _router: Router,
        private _Globals: Globals
    ) {
        this._Globals.setMode("");//disable the side menu
        this._Globals.setAvailableModes("");
        this._Globals.setUserType("");
    }

    ngOnInit() {

        if (this._Globals.assesmentErrorMessage != "") {
            this.errorMessage = this._Globals.assesmentErrorMessage;
        } else {
            this.toLogin();
        }
    }

    toLogin() {
        console.log('redirect to login');
        this._router.navigate(['/login']);
    }

}
